import React, { useEffect, useState, useRef } from 'react'
import MainLayout from '../../containers/MainLayout'
import Loader from '../../baseComponents/Loader'
import PageTitle from '../../baseComponents/PageTitle'
import { Fade } from 'react-slideshow-image'

import { getSanferGlobal } from '../../services/us'
import { connect } from 'react-redux'
import { langTexts } from './locals'

import titleLogo from '../../assets/images/title-icons/Internet-Line.svg'
import { ReactComponent as Logo } from '../../assets/images/title-icons/Internet-Line.svg'

import { useLocation } from 'react-router-dom'

import arrow from '../../assets/images/svg_icons/arrow.svg'
import arrowSlide from '../../assets/images/svg_icons/map_arrow.svg'


import './index.css'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const SanferGlobal = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  const [isFetching, setIsFetching] = useState(true)
    , [data, setData] = useState(null)
    , [activeCompany, setActiveCompany] = useState('0')
    , [activeClass, setActiveClass] = useState('')
    , [currentSlide, setCurrentSlide] = useState(0)
    , slideRef = useRef(null)
  // , [currentSlideSelector, setCurrentSlideSelector] = useState(0)
  // , slideSelectorRef = useRef(null)

  let query = useQuery()

  const onChangeSlide = (type) => {
    const element = document.getElementById("slider-container");
    if (type === "top" && element) {
      element.scrollTop -= 100;
    } else {
      element.scrollTop += 100;
    }
  };

  /* const onChangeSlideSelector = (previous, next) => {
    setCurrentSlideSelector(next);
  }; */

  const onClick = (company) => {
    if (company === activeCompany) return null
    setActiveCompany('')
    setCurrentSlide(0)
    setTimeout(() => {
      setActiveCompany(company)
    }, 500)
  }

  const onPlay = () => {
  }

  useEffect(() => {
    let timeout = null
    getSanferGlobal()
      .then(res => {
        setData(res)
        setIsFetching(false)

        if (query.get('key') && query.get('key').length) {
          let companies = res[lang] && res[lang].companies instanceof Array
            ? res[lang].companies
            : []
            , key = query.get('key')
            , item = companies.map((company, index) => company.title === key ? index : null).find(e => Number.isInteger(e))
          if (item) setActiveCompany(String(item))
        }

        timeout = setTimeout(() => {
          setActiveClass('active')
        }, 800)
      })
      .catch(err => console.log(err))
    return () => {
      clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  if (isFetching) return <Loader />

  let info = data[lang]
    , companies = Object.keys(info.companies)
    , activeCompanyInfo = info.companies[activeCompany]
      ? info.companies[activeCompany]
      : null

  let title = info.title ? info.title : texts.title
    , label = info.titleRedLabel ? info.titleRedLabel : ''


  const zoomInProperties = {
    autoplay: activeCompanyInfo && activeCompanyInfo.gallery.length > 1,
    indicators: false,
    arrows: false,
    pauseOnHover: true,
    scale: 1.4
  }

  /* const zoomInPropertiesSelector = {
    easing: 'cubic',
    autoplay: false,
    indicators: false,
    arrows: false,
    scale: 1.4,
    centerMode: true,
    variableWidth: true
  } */

  let slider = activeCompanyInfo && activeCompanyInfo.gallery ? activeCompanyInfo.gallery : []
  slider = slider.map(slide => ({ source: slide, type: 'images' }))

  if (activeCompanyInfo && activeCompanyInfo.videos instanceof Array) {
    let videos = activeCompanyInfo.videos.map(slide => ({ source: slide, type: 'video' }))
    slider = [...videos, ...slider]
  }

  return (
    <MainLayout
      id="global"
      className={`${activeClass} transition`}
      logo={<Logo />}
    >
      <PageTitle title={title} label={label} logo={titleLogo} />
      <div
        className="global__description"
        dangerouslySetInnerHTML={{ __html: info.paragraphs }}
      />

      <div className="global__subtitle">
        <div className="gray-line" />
        <p>{texts.subtitle}</p>
      </div>

      <div className="global__companies">
        <div className="gray-line" />
        <div className="global__companies-container">
          <div className="global__companies-selector">
            {companies.map((company) => {
              let companyInfo = info.companies[company];
              return (
                <img
                  className={`global__company-item ${company === activeCompany ? "active" : ""
                    }`}
                  key={company}
                  src={companyInfo.smallLogo}
                  onClick={() => onClick(company)}
                  alt={company}
                />
              );
            })}
          </div>
          <div className="global__companies-selector-mobile">
            <div className="slider">
              <img
                onClick={() => onChangeSlide("top")}
                className="arrow top"
                src={arrowSlide}
                alt="flecha"
              />
              <div id="slider-container" className="slider-container">
                {companies.map((company, index) => {
                  let companyInfo = info.companies[company];
                  return (
                    <img
                      className={`global__company-item ${company === activeCompany ? "active" : ""
                        }`}
                      key={company}
                      src={companyInfo.smallLogo}
                      onClick={() => onClick(company)}
                      alt={company}
                    />
                  );
                })}
              </div>
              <img
                onClick={() => onChangeSlide("bottom")}
                className="arrow bottom"
                src={arrowSlide}
                alt="flecha"
              />
            </div>
          </div>
          {/* <div className='global__companies-selector-mobile'>
          <div className='companies__slider-container'>
            <Fade ref={slideSelectorRef} {...zoomInPropertiesSelector} onChange={onChangeSlideSelector}>
              {
                companies.map((company, index) => {
                  let companyInfo = info.companies[company]
                  return <img
                    className={`global__company-item ${company === activeCompany ? 'active' : ''}`}
                    key={company}
                    src={companyInfo.smallLogo}
                    onClick={() => onClick(company)}
                    alt={company} />
                })
              }
            </Fade>
          </div>
          <div className='about-us__slider-bullets-container companies__slider-bullets-container'>
            {
              companies.length > 1 &&
              companies.map((company, index) => <div
                key={index}
                className={`bullet ${currentSlideSelector === index ? 'current' : ''} transition`}
                onClick={() => {
                  onClick(company)
                  setCurrentSlideSelector(index)
                  slideSelectorRef.current.goTo(index)
                }}
              />)
            }
          </div>
        </div> */}

          <div
            className={`global__company-info ${activeCompany.length ? "active" : ""
              } transition-fast`}
          >
            {activeCompanyInfo ? (
              <React.Fragment>
                <img
                  className="global__company-info-logo"
                  src={activeCompanyInfo.bigLogo}
                  alt={activeCompany}
                />
                <div
                  className="gray-color global__company-desc"
                  dangerouslySetInnerHTML={{
                    __html: activeCompanyInfo.description,
                  }}
                />

                <div className="global__company-slider transition ">
                  <div className="global__company-slider-container">
                    <Fade
                      ref={slideRef}
                      {...zoomInProperties}
                      onChange={onChangeSlide}
                    >
                      {slider.map((item, index) => {
                        if (item.type === "video")
                          return (
                            <div
                              key={index}
                              className="global__company-slider-image"
                              style={{ background: "black" }}
                            >
                              <video
                                onPlay={onPlay}
                                src={item.source}
                                controls
                                autoPlay={currentSlide === index}
                              ></video>
                            </div>
                          );

                        return (
                          <div
                            key={index}
                            className="global__company-slider-image"
                            style={{ background: `url(${item.source})` }}
                          ></div>
                        );
                      })}
                    </Fade>
                  </div>
                  <div className="operations__slider-bullets-container">
                    {slider.length > 1 &&
                      slider.map((item, index) => (
                        <div
                          key={index}
                          className={`bullet ${currentSlide === index ? "current" : ""
                            } transition`}
                          onClick={() => {
                            setCurrentSlide(index);
                            slideRef.current.goTo(index);
                          }}
                        />
                      ))}
                  </div>
                </div>

                {typeof activeCompanyInfo.website === "string" &&
                  activeCompanyInfo.website.length && (
                    <a
                      href={activeCompanyInfo.website}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {texts.visit}
                      <img className="arrow-left" src={arrow} alt="flecha" />
                    </a>
                  )}
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

const mapStateToProps = state => ({
  settings: state.settings
})

export default connect(mapStateToProps)(SanferGlobal)
